// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Weekday from "../../../domain/types/common/Weekday.bs.js";
import * as SurgeStrategy from "../../../domain/types/surge/SurgeStrategy.bs.js";
import * as CampaignStatus from "../../../domain/types/surge/CampaignStatus.bs.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as CrmRepoManager from "../../../domain/repo/CrmRepoManager.bs.js";
import * as SurgeViewUtils from "../SurgeViewUtils.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as DateTime$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";
import * as Ellipsis$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/Ellipsis.bs.js";
import * as ViewUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ViewUtils.bs.js";
import * as DeleteCampaignModal from "./DeleteCampaignModal.bs.js";
import * as TableComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";
import * as TertiaryButton$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/TertiaryButton.bs.js";

function getActionBtns(status, onDelete, campaignId) {
  return React.createElement("div", {
              className: "u-flex-wrap"
            }, status === /* Active */0 ? React.createElement(TertiaryButton$Catalyst.make, {
                    className: "btn-tertiary--red",
                    onSelectCB: (function (_event) {
                        return Curry._1(onDelete, campaignId);
                      }),
                    children: "Delete"
                  }) : null);
}

function getSurgeStrategyView(surgeStrategy) {
  if (surgeStrategy.TAG === /* Flat */0) {
    var amount = surgeStrategy._0;
    return SurgeStrategy.getDisplayName({
                TAG: /* Flat */0,
                _0: amount
              }) + (", " + String(amount));
  }
  var multiplier = surgeStrategy._0;
  return SurgeStrategy.getDisplayName({
              TAG: /* Multiplier */1,
              _0: multiplier
            }) + (", " + multiplier.toString());
}

function getZones(campaign) {
  var zones = campaign.zones;
  if (zones === undefined) {
    return "N/A";
  }
  var partial_arg = List.map((function (zone) {
          return zone.description;
        }), zones);
  return ViewUtils$Catalyst.createViewFromList(partial_arg, ",");
}

function getTableColumnsSchema(onDelete) {
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "Campaign Name"
            },
            accessor: (function (campaign) {
                return {
                        TAG: /* Text */0,
                        _0: campaign.campaignName
                      };
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Vehicle Types"
              },
              accessor: (function (campaign) {
                  return {
                          TAG: /* Text */0,
                          _0: ViewUtils$Catalyst.createViewFromList(List.map((function (vehicle) {
                                      return SurgeViewUtils.createVehicleCategoryLabel(vehicle.name, vehicle.id);
                                    }), campaign.vehicleTypeDetail), ",")
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "Surge Details"
                },
                accessor: (function (campaign) {
                    return {
                            TAG: /* Text */0,
                            _0: getSurgeStrategyView(campaign.surgeStrategy)
                          };
                  })
              },
              tl: {
                hd: {
                  column: {
                    TAG: /* Text */0,
                    _0: "Start Date"
                  },
                  accessor: (function (campaign) {
                      return {
                              TAG: /* Text */0,
                              _0: DateTime$Catalyst.toString("MMM Do YY", campaign.campaignStartDate)
                            };
                    })
                },
                tl: {
                  hd: {
                    column: {
                      TAG: /* Text */0,
                      _0: "End Date"
                    },
                    accessor: (function (campaign) {
                        return {
                                TAG: /* Text */0,
                                _0: DateTime$Catalyst.toString("MMM Do YY", campaign.campaignEndDate)
                              };
                      })
                  },
                  tl: {
                    hd: {
                      column: {
                        TAG: /* Text */0,
                        _0: "RepeatOn"
                      },
                      accessor: (function (campaign) {
                          return {
                                  TAG: /* Text */0,
                                  _0: ViewUtils$Catalyst.createViewFromList(List.map(Weekday.toString, campaign.weekdays), ",")
                                };
                        })
                    },
                    tl: {
                      hd: {
                        column: {
                          TAG: /* Text */0,
                          _0: "Start Time"
                        },
                        accessor: (function (campaign) {
                            return {
                                    TAG: /* Text */0,
                                    _0: DateTime$Catalyst.toString("HH:mm", DateTime$Catalyst.getDateTimeAfterElapsedTime(campaign.windowStartMins, "minutes", new Date("1970-01-01:00:00")))
                                  };
                          })
                      },
                      tl: {
                        hd: {
                          column: {
                            TAG: /* Text */0,
                            _0: "End Time"
                          },
                          accessor: (function (campaign) {
                              return {
                                      TAG: /* Text */0,
                                      _0: DateTime$Catalyst.toString("HH:mm", DateTime$Catalyst.getDateTimeAfterElapsedTime(campaign.windowEndMins, "minutes", new Date("1970-01-01:00:00")))
                                    };
                            })
                        },
                        tl: {
                          hd: {
                            column: {
                              TAG: /* Text */0,
                              _0: "Creator"
                            },
                            accessor: (function (campaign) {
                                return {
                                        TAG: /* Text */0,
                                        _0: campaign.administratorDetail.email
                                      };
                              })
                          },
                          tl: {
                            hd: {
                              column: {
                                TAG: /* Text */0,
                                _0: "Status"
                              },
                              accessor: (function (campaign) {
                                  return {
                                          TAG: /* Text */0,
                                          _0: CampaignStatus.toString(campaign.status)
                                        };
                                })
                            },
                            tl: {
                              hd: {
                                column: {
                                  TAG: /* Text */0,
                                  _0: "Priority"
                                },
                                accessor: (function (campaign) {
                                    return {
                                            TAG: /* Text */0,
                                            _0: "P-" + String(campaign.priority)
                                          };
                                  })
                              },
                              tl: {
                                hd: {
                                  column: {
                                    TAG: /* Text */0,
                                    _0: "Zones"
                                  },
                                  accessor: (function (campaign) {
                                      return {
                                              TAG: /* Custom */5,
                                              _0: (function (param) {
                                                  return React.createElement("div", {
                                                              className: "ellipsis-container"
                                                            }, React.createElement(Ellipsis$Catalyst.make, {
                                                                  content: getZones(campaign)
                                                                }));
                                                })
                                            };
                                    })
                                },
                                tl: {
                                  hd: {
                                    column: {
                                      TAG: /* Text */0,
                                      _0: "Delete Campaign"
                                    },
                                    accessor: (function (campaign) {
                                        return {
                                                TAG: /* Custom */5,
                                                _0: (function (param) {
                                                    return getActionBtns(campaign.status, onDelete, campaign.campaignId);
                                                  })
                                              };
                                      })
                                  },
                                  tl: /* [] */0
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        };
}

function getTable(tableData, onDelete) {
  return React.createElement("div", {
              className: "table-wrapper"
            }, React.createElement(TableComponent$Catalyst.make, {
                  columns: getTableColumnsSchema(onDelete),
                  rowData: tableData,
                  className: "customTable"
                }));
}

function SurgeTableComponent(Props) {
  var campaigns = Props.campaigns;
  var refreshView = Props.refreshView;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useReducer((function (state, action) {
          if (typeof action === "number") {
            return {
                    requestStatus: state.requestStatus,
                    showModal: !state.showModal,
                    campaignId: state.campaignId
                  };
          }
          switch (action.TAG | 0) {
            case /* OnSuccess */0 :
                return {
                        requestStatus: {
                          TAG: /* Live */1,
                          _0: action._0
                        },
                        showModal: state.showModal,
                        campaignId: state.campaignId
                      };
            case /* OnError */1 :
                return {
                        requestStatus: {
                          TAG: /* Error */2,
                          _0: action._0
                        },
                        showModal: state.showModal,
                        campaignId: state.campaignId
                      };
            case /* DeleteCampaign */2 :
                return {
                        requestStatus: {
                          TAG: /* Loading */0,
                          _0: undefined
                        },
                        showModal: true,
                        campaignId: action._0
                      };
            
          }
        }), {
        requestStatus: /* Init */0,
        showModal: false,
        campaignId: undefined
      });
  var dispatch = match$1[1];
  var state = match$1[0];
  React.useEffect((function () {
          var _data = state.requestStatus;
          if (typeof _data !== "number" && _data.TAG === /* Loading */0) {
            var SurgeRepo = CrmRepoManager.getSurgeRepo(undefined);
            var campaignId = state.campaignId;
            if (campaignId !== undefined) {
              ApiUtils$Catalyst.handleAPIRequest((function (param) {
                      return Curry._2(SurgeRepo.deleteCampiagn, campaignId, country);
                    }), (function (data) {
                      return Curry._1(dispatch, {
                                  TAG: /* OnSuccess */0,
                                  _0: data
                                });
                    }), (function (message) {
                      return Curry._1(dispatch, {
                                  TAG: /* OnError */1,
                                  _0: message
                                });
                    }));
            }
            
          }
          
        }), [state.requestStatus]);
  return React.createElement("div", undefined, getTable(campaigns, (function (campaignId) {
                    return Curry._1(dispatch, {
                                TAG: /* DeleteCampaign */2,
                                _0: campaignId
                              });
                  })), state.showModal ? React.createElement(DeleteCampaignModal.make, {
                    refreshView: refreshView,
                    onToggle: (function (param) {
                        return Curry._1(dispatch, /* OnToggle */0);
                      }),
                    requestState: state.requestStatus
                  }) : null);
}

var make = SurgeTableComponent;

export {
  getActionBtns ,
  getSurgeStrategyView ,
  getZones ,
  getTableColumnsSchema ,
  getTable ,
  make ,
  
}
/* react Not a pure module */
